import { ProductionModuleLayout } from "@features/production/components/ProductionModuleLayout";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/production")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.DASHBOARD.VIEW, {
    redirectTo: "/unauthorized",
  }),
  staticData: {
    title: "Production",
    permission: PERMISSIONS.PRODUCTION.DASHBOARD.VIEW,
    module: "production",
    section: "Production",
    order: 40,
    showInNav: true,
  },
  component: ProductionModuleLayout,
});
